import { Backdrop, Box, IconButton, Popover, Stack } from "@mui/material";
import {
  COLOR_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
  COLOR_WHITE,
} from "../../../data/colors/Colors";
import { SportsEsportsRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import useWindowDimensions from "../../../core/utils/UseWindowDimensions";
import { NewGameView } from "../newGame/NewGameView";
import { Player } from "../../../domain/model/User";

export function PlayGameFabView({ player }: { player: Player | undefined }) {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() == "rtl";

  const { width, height } = useWindowDimensions();

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl) && player != undefined;
  const id = open ? "simple-popover" : undefined;

  const [popoverContentHeight, setPopoverContentHeight] = useState("auto");

  return (
    <Box
      display={{
        xl: "none",
        lg: "none",
        md: "none",
        sm: undefined,
        xs: undefined,
      }}
    >
      <Box
        position={"fixed"}
        right={isRtl ? undefined : 0}
        left={isRtl ? 0 : undefined}
        bottom={0}
        p={2}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <IconButton
          sx={{
            background: COLOR_MAIN,
            width: "4rem",
            height: "4rem",
            boxShadow: 20,
            "&:hover": {
              background: COLOR_LIGHT_GRAY,
              "@media (hover: none)": {
                backgroundColor: COLOR_MAIN,
              },
            },
          }}
          onClick={handleClick}
        >
          <SportsEsportsRounded fontSize="large" sx={{ color: COLOR_WHITE }} />
        </IconButton>
      </Box>

      <Backdrop
        open={open}
        sx={{ color: COLOR_BLACK, zIndex: (theme) => theme.zIndex.drawer + 2 }}
      >
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={() => {}}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          slotProps={{
            paper: {
              style: {
                borderRadius: 20,
                width:
                  width < 700 ? width : width / height > 2 ? "50vw" : "30vw",
                height: popoverContentHeight,
              },
            },
          }}
        >
          {player && (
            <>
              <NewGameView
                handleClose={handleClose}
                handleHeightChanged={(h) => setPopoverContentHeight(h)}
                player={player}
              />
            </>
          )}
        </Popover>
      </Backdrop>
    </Box>
  );
}
